import { type TiledMap } from '@veriverse/map-format';
import { type OfficeLocation } from '@veriverse/shared';
import { type Room } from 'colyseus.js';
import Phaser from 'phaser';
import { WORLD_SCENE_KEY, WorldScene } from './scenes/world-scene.js';

/** Creates the Phaser game inside `parent` and starts the world for the joined room. */
export function createGame(
  parent: HTMLElement,
  room: Room,
  map: TiledMap,
  office: OfficeLocation,
): Phaser.Game {
  const game = new Phaser.Game({
    type: Phaser.AUTO,
    parent,
    backgroundColor: '#14161e',
    pixelArt: true, // nearest-neighbour sampling, no smoothing (spec §9.2)
    roundPixels: true,
    scale: {
      mode: Phaser.Scale.RESIZE,
      width: parent.clientWidth,
      height: parent.clientHeight,
    },
    // Keep keyboard events from reaching the page while the game has focus.
    input: { keyboard: { target: window } },
    scene: [],
  });
  game.scene.add(WORLD_SCENE_KEY, WorldScene, true, { room, map, office });
  return game;
}
